import styled from 'styled-components';

const tagColors = {
  pink: {
    light: '#f8d1e6',
    dark: '#5c1433',
  },
  purple: {
    light: '#e5d1fa',
    dark: '#33175d',
  },
  orange: {
    light: '#fae7d1',
    dark: '#5c3311',
  },
  yellow: {
    light: '#faf9d1',
    dark: '#5c3311',
  },
  green: {
    light: '#def8e9',
    dark: '#006e2e',
  },
  blue: {
    light: '#d5d2fb',
    dark: '#13155c',
  },
};

export const Container = styled.div`
  & .data-row {
    padding: 24px 30px;
    & .data-column {
      flex: 1;
      padding: 0 40px 0 0;
    }
    & .data-column:nth-child(1) {
      flex: 1.7;
    }
    & .data-column:nth-child(2) {
      flex: 1.6;
    }
    & .data-column:nth-child(3) {
      flex: 2;
    }
    & .data-column:nth-child(4) {
      flex: 1;
    }
    & .data-column:nth-child(5) {
      flex: 2.4;
    }
    & .data-column:nth-child(6) {
      flex: 2.1;
      padding-right: 0;
    }
    & .arrow {
      background: none;
      border: none;
      &:active,
      &:focus {
        outline: none;
      }
    }
  }
  & .data-content {
    & .data-row {
      position: relative;
      & .highlighter {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 2px;
        opacity: 0.5;
        &.pink {
          background-color: ${tagColors.pink.dark};
        }
        &.purple {
          background-color: ${tagColors.purple.dark};
        }
        &.yellow {
          background-color: ${tagColors.yellow.dark};
        }
        &.green {
          background-color: ${tagColors.green.dark};
        }
        &.blue {
          background-color: ${tagColors.blue.dark};
        }
        &.orange {
          background-color: ${tagColors.orange.dark};
        }
      }
      .date {
        opacity: 0.5;
      }
      & .column {
        flex: 1;
        padding: 0 40px 0 0;
        font-size: 0.875rem;
        display: flex;
        &.column:nth-child(1) {
          flex: 1.7;
        }
        &.column:nth-child(2) {
          flex: 1.6;
        }
        &.column:nth-child(3) {
          flex: 2;
          flex-direction: column;
        }
        &.column:nth-child(4) {
          flex: 1;
        }
        &.column:nth-child(5) {
          flex: 2.4;
          flex-direction: column;
          .cl16 {
            margin-right: 16px;
            width: 45%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            z-index: 1;
          }
        }
        &.column:nth-child(6) {
          flex: 2.1;
          padding-right: 0;
          .margl16 {
            margin-left: 16px;
          }
        }
      }
    }
  }
`;

export const Tag = styled.span`
  line-height: 1;
  min-width: 18px;
  max-height: 18px;
  margin-top: 3px;
  padding: 3px;
  border-radius: 5px;
  color: #17191a;
  background-color: #f6f6f7;
  text-align: center;
  margin-right: 8px;
  &.purple {
    color: ${tagColors.purple.dark};
    background-color: ${tagColors.purple.light};
  }
  &.orange {
    color: ${tagColors.orange.dark};
    background-color: ${tagColors.orange.light};
  }
  &.yellow {
    color: ${tagColors.yellow.dark};
    background-color: ${tagColors.yellow.light};
  }
  &.green {
    color: ${tagColors.green.dark};
    background-color: ${tagColors.green.light};
  }
  &.pink {
    color: ${tagColors.pink.dark};
    background-color: ${tagColors.pink.light};
  }
  &.blue {
    color: ${tagColors.blue.dark};
    background-color: ${tagColors.blue.light};
  }
`;
